import React from "react";
import { dayOptions, weekDayOptions } from "../config/dayOptions";
import TeamMembersList from "../components/TeamMembersList";
import { MultiSelect } from "../components/MultiSelect";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMoodsTranslator } from "../../settings/components/useMoodsTranslator";
import { useCause } from "../../../contexts/CauseContext";
import { useTeam } from "../../../contexts/TeamContext";
import { TeamNameInput } from "../components/TeamNameInput";
import { DeleteTeam } from "../components/DeleteTeam";
import styles from "../components/TeamSettings.module.css";

type TeamDetailsAddProps = {
  teamId: string;
  name: string;
  setName: (name: string) => void;
  organizationId: string | null | undefined;
  selectedNotifications: string[];
  onNotificationsChange: (selectedValues: string[]) => void;
  selectedCauseTypeIds: string[];
  onCauseTypeIdsChange: (selectedValues: string[]) => void;
  reportDay: string;
  onReportDayChange: (day: string) => void;
};

export const TeamEdit = ({
  teamId,
  name,
  setName,
  organizationId,
  selectedNotifications,
  onNotificationsChange,
  selectedCauseTypeIds,
  onCauseTypeIdsChange,
  reportDay,
  onReportDayChange,
}: TeamDetailsAddProps) => {
  const { causeTypes, setActiveCauseTypes } = useCause();
  const { setActiveTeamCauseTypes } = useTeam();
  const { t } = useTranslation();
  const moodsTranslator = useMoodsTranslator();
  const { state } = useLocation();
  const type = state?.type;
  const visibleAvailableOptions = dayOptions.map((option) =>
    option.link === "/app/settings/teams"
      ? {
          ...option,
          state: { ...option.state },
        }
      : option
  );

  return (
    <>
      Check-In Days
      <TeamNameInput name={name} setName={setName} />
      <MultiSelect
        options={visibleAvailableOptions}
        initialSelectedValues={selectedNotifications}
        onSelectionChange={onNotificationsChange}
      />
      Members
      <TeamMembersList isEditing={true} teamId={teamId} />
      Causes
      <MultiSelect
        moodsTranslator={moodsTranslator}
        causeTypes={causeTypes}
        organizationId={organizationId}
        t={t}
        type={type}
        setActiveCauseTypes={setActiveCauseTypes}
        setActiveTeamCauseTypes={setActiveTeamCauseTypes}
        initialSelectedValues={selectedCauseTypeIds}
        onSelectionChange={onCauseTypeIdsChange}
      />
      <span className="secondary-title">Report day</span>
      <div className="duration-field-row">
        <select
          className={styles["team-settings-invite-form-input"]}
          value={reportDay}
          onChange={(event) => onReportDayChange(event.target.value)}
          aria-label="Report day"
        >
          <option value="">Select day</option>
          {weekDayOptions.map((day) => (
            <option key={day} value={day}>
              {day}
            </option>
          ))}
        </select>
      </div>
      <DeleteTeam teamId={teamId} />
    </>
  );
};
